/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { CourseFinancialListItemViewModel } from "../types/CourseFinancialListItemViewModel.ts";

export const courseFinancialListItemViewModelSchema = z.object({
  id: z.optional(z.number().int().describe("ID do plano financeiro.")),
  courseId: z.optional(z.number().int().describe("ID do curso.")),
  description: z.string().describe("Descrição do plano.").nullish(),
  startDate: z.optional(
    z.string().datetime().describe("Início da vigência do plano."),
  ),
  endDate: z
    .string()
    .datetime()
    .describe("Fim da vigência do plano. Opcional.")
    .nullish(),
  totalValue: z.number().describe("Valor total do plano. Opcional.").nullish(),
  valueRegistration: z
    .number()
    .describe("Taxa de inscrição. Opcional.")
    .nullish(),
  active: z.optional(z.boolean().describe("Indica se o plano está ativo.")),
  internationalPlan: z.optional(
    z.boolean().describe("Indica se é um plano internacional."),
  ),
  hasEnrollment: z.optional(
    z
      .boolean()
      .describe("Indica se o plano já foi escolhido por alguma matrícula."),
  ),
  canBeDeleted: z.optional(
    z
      .boolean()
      .describe(
        "Indica se a exclusão será física. Com matrícula, a exclusão apenas inativa o plano.",
      ),
  ),
  paymentMethodCount: z.optional(
    z
      .number()
      .int()
      .describe("Quantidade de formas de pagamento configuradas."),
  ),
  classCount: z.optional(
    z
      .number()
      .int()
      .describe(
        "Quantidade de turmas vinculadas. Zero significa que o plano vale para todas as turmas do curso.",
      ),
  ),
  langCount: z.optional(
    z
      .number()
      .int()
      .describe("Quantidade de idiomas com descrição cadastrada."),
  ),
  lastChangeDate: z
    .string()
    .datetime()
    .describe("Data da última alteração. Opcional.")
    .nullish(),
  userLastChange: z
    .string()
    .describe("Usuário responsável pela última alteração. Opcional.")
    .nullish(),
}) as unknown as ToZod<CourseFinancialListItemViewModel>;
